module.exports = __webpack_public_path__ + "img/12i.77336c73.png";